module.exports = __webpack_public_path__ + "img/CD.7197f50b.png";